/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateMessage = /* GraphQL */ `
  subscription OnCreateMessage($clubId: String!) {
    onCreateMessage(clubId: $clubId) {
      id
      userId
      username
      content
      replyContent
      clubChannelId
      clubId
      createdAt
      isSent
    }
  }
`;
export const onUpdateMessage = /* GraphQL */ `
  subscription OnUpdateMessage(
    $id: ID
    $userId: String
    $content: String
    $clubChannelId: String
    $createdAt: String
  ) {
    onUpdateMessage(
      id: $id
      userId: $userId
      content: $content
      clubChannelId: $clubChannelId
      createdAt: $createdAt
    ) {
      id
      userId
      username
      content
      replyContent
      clubChannelId
      clubId
      createdAt
      isSent
    }
  }
`;
export const onDeleteMessage = /* GraphQL */ `
  subscription OnDeleteMessage(
    $id: ID
    $userId: String
    $content: String
    $clubChannelId: String
    $createdAt: String
  ) {
    onDeleteMessage(
      id: $id
      userId: $userId
      content: $content
      clubChannelId: $clubChannelId
      createdAt: $createdAt
    ) {
      id
      userId
      username
      content
      replyContent
      clubChannelId
      clubId
      createdAt
      isSent
    }
  }
`;
